import React, { Suspense, useEffect, useState, useRef } from 'react'
import './assets/styles/App.scss'
import 'antd/dist/antd.min.css'
import './assets/styles/custom.scss'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import { isLoggedIn } from './utils/userUtils'
import generateRoutes, { fallbackRoutes } from './router'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from './redux/store'
import { processWebMenu } from './utils/menuUtils'
import { getListMenuFail, getListMenuSuccess } from './redux/ducks/menuDucks'
import Loadding from './components/layout/Loadding'
import BasicLayout from './components/layout/BasicLayout'
import * as userApi from './api/userApi';

const URL_LOGIN_ALL_SYSTEM = (process.env.REACT_APP_AUTH_URL || "http://localhost:3000") + '/login-all'

const App: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch()
  const isMounted = useRef(true)
  const [isLoading, setIsLoading] = useState(true)
  const [routes, setRoutes] = useState<any[]>(fallbackRoutes)
  
  // Lấy menu data từ Redux store
  const { webChucNangAll, webUrls } = useSelector((state: RootState) => state.menu)

  useEffect(() => {
    const currentRoute = routes.find((route) => route.path === location.pathname);
    if (currentRoute && currentRoute.title) {
      document.title = 'MH - ' + currentRoute.title;
    } else {
      document.title = 'MUA HÀNG';
    }
  }, [location, routes]);

  useEffect(() => {
    isMounted.current = true
    fetchMyMenu()
    
    return () => {
      isMounted.current = false
    }
  }, [])

  // Cập nhật routes khi menu data thay đổi
  useEffect(() => {
    if (webChucNangAll && webChucNangAll.length > 0) {
      try {
        const updatedRoutes = generateRoutes(webChucNangAll)
        
        setRoutes(updatedRoutes)
      } catch (error) {
        setRoutes(fallbackRoutes)
      }
    }
  }, [webChucNangAll, webUrls, location.pathname])

  const fetchMyMenu = async () => {
    try {
      if (isMounted.current) setIsLoading(true)
      const res: any = await userApi.getMyMenu()

      if (isMounted.current && res.data && Array.isArray(res.data)) {
        const { webUrls, webChucNangs, webChucNangAll } = processWebMenu(res.data)
        
        dispatch(getListMenuSuccess({
          webUrls: webUrls,
          webChucNangs: webChucNangs,
          webChucNangAll: webChucNangAll
        }))
      }
    } catch (error) {
      if (isMounted.current) {
        dispatch(getListMenuFail({
          webUrls: [],
          webChucNangs: [],
          webChucNangAll: []
        }))
      }
    } finally {
      if (isMounted.current) setIsLoading(false)
    }
  }

  // Hiển thị loading khi đang fetch menu data
  if (isLoading) {
    return <Loadding />
  }

  return (
    <Suspense fallback={<Loadding />}>
      <Switch>
        {routes.map(({ component: Component, path, exact, name, layout: Layout }) => (
          <Route
            key={name}
            exact={exact}
            path={path}
            render={(props: any) => {
              return (
                <Layout>
                  {isLoggedIn() ? (
                    path === '/login' ? (
                      <Redirect push to="/" />
                    ) : (
                      <Component {...props} />
                    )
                  ) : path === '/login' || path === '/privacy-policy' || path === '/developer/contact' ? (
                    <Component {...props} />
                  ) :
                    path.includes('setting-token') ? (
                      <Component {...props} />
                    ) : (
                      // <Redirect push to="/login" />
                      window.location.href = `${URL_LOGIN_ALL_SYSTEM}?hethong=muahang&redirect_url=${location.pathname}`
                    )}
                </Layout>
              )
            }}
          />
        ))}
        {/* Fallback route - chỉ render khi không có route nào match */}
        <Route path="*" render={() => {
          return (
            <BasicLayout>
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>404 - Trang không tồn tại</h2>
              </div>
            </BasicLayout>
          )
        }} />
      </Switch>
    </Suspense>
  )
}

export default App
